<template>
  <div
    v-if="mostrar"
    class="janela-flutuante"
  >
    <h3>Janela 80%</h3>
    <p>Centralizada na tela, sem overlay.</p>
    <v-btn color="primary" @click="mostrar = false">Fechar</v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return { mostrar: true }
  }
}
</script>

<style scoped>
.janela-flutuante {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  padding: 20px;
  overflow: auto;
  z-index: 9999;
}
</style>
